/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixComponentBase {
    getFixupPrototypeFunction() { return ZabbixComponentBase.fixupPrototype; }

    static newInstance(model: Partial<ZabbixComponentBase>): ZabbixComponentBase {
        let obj = Object.assign(new ZabbixComponentBase(), model);
        ZabbixComponentBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixComponentBase>): ZabbixComponentBase {
        if (!model) return null;
        return ZabbixComponentBase.newInstance(<ZabbixComponentBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixComponentBase) {
        if (!obj) return;

        models.ZabbixComponentBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixComponentBase): boolean {
        Object.setPrototypeOf(obj, ZabbixComponentBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the Zabbix component
     */
    item_id: string;

    /**
     * Name of the component
     */
    name: string;

}
